<template>
  <div id="loading-wrapper">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-auto align-self-center" style="opacity: 0.7;">
          <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
          <br>
          <strong>{{ text }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loader',
  props: {
    text: {
      type: String,
      default: 'Cargando'
    }
  }
}
</script>

<style lang="scss">
  #loading-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba($color: #ffffff, $alpha: 0.9);
    left: 0;
    top: 0;
  }
  .container-fluid {
    height: 100%;
    .row {
      height: 100%;
      .col-auto {
        text-align: center;
      }
    }
  }
</style>
